package com.solevo.dist.application.models

import com.solevo.dist.utils.time.startOfDay
import com.solevo.dist.utils.time.toCurrentLocalDateTime
import kotlinx.datetime.Clock
import kotlinx.datetime.Instant

data class Transaction(
    val transactionId: String = "",
    val legalEntityId: String? = null,
    val voucherId: String? = "",
    var invoiceNumber: String? = "",
    val customerId: String = "",
    val type: Type = Type.Payment,
    val date: Instant = Clock.System.now(),
    val invoiceDueDate: Instant? = null,
    val invoiceId: String? = "",
    val amount: Double = 0.0,
    val originalAmount: Double = 0.0,
    val remainingAmount: Double = 0.0,
    val currency: String = "",
    val status: Status = Status.Open
) {

    val invoiceStatus: InvoiceStatus
        get() {
            var _invoiceStatus: InvoiceStatus = InvoiceStatus.Closed
            val overdueDate = invoiceDueDate ?: date
            val isOverdue = overdueDate.startOfDay() < Clock.System.now().toCurrentLocalDateTime()
            if (status == Status.Open) {
                _invoiceStatus = if (isOverdue) InvoiceStatus.Overdue else InvoiceStatus.DueToPay
            }
            return _invoiceStatus
        }

    sealed class Status {
        data object Open : Status()
        data object Closed : Status()

        companion object {
            fun fromString(value: String): Status {
                return when (value) {
                    "Open" -> Open
                    "Closed" -> Closed
                    else -> throw IllegalArgumentException("Invalid TransactionStatus value: $value")
                }
            }
        }
    }

    sealed class Type {
        data object Payment : Type()
        data object CreditNote : Type()
        data object Invoice : Type()
        data object Other : Type()
        data object Reimbursement : Type()

        companion object {
            fun fromString(value: String): Type {
                return when (value) {
                    "Payment" -> Payment
                    "CreditNote" -> CreditNote
                    "Invoice" -> Invoice
                    "Other" -> Other
                    "Reimbursement" -> Reimbursement
                    else -> throw IllegalArgumentException("Invalid TransactionType value: $value")
                }
            }
        }
    }
}
